const colors = {
  primary: "#006156",
  error: "#B51622",
  white: "#FFFFFF",
};

export default colors;
